import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import { getMcaV3Credentials } from "api/services/organization";
import { McaMasterData, McaFilingStatus, McaCompanyDetails, alerttt } from "assets";
import useTitle from "hooks/useTitle";
import { useState } from "react";
import { QueryFunctionContext, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import AddMcaV3Credentials from "views/settings/organization/OrganizationProfile/Mca/AddMcaV3Credentials";

const services = [
    {
        title: "CIN Master Data",
        subtitle: "Company Master Data lookup",
        icon: <img src={McaMasterData} alt="McaMasterData" height="40px" />,
        path: "/atom-pro/mca/services/master-data",
    },
    {
        title: "Check Annual Filing Status",
        subtitle: "Verify MCA filing compliance status",
        icon: <img src={McaFilingStatus} alt="McaFilingStatus" height="40px" />,
        path: "/atom-pro/mca/services/filling-status",
    },
    {
        title: "Check Company / LLP Name",
        subtitle: "Search name availability",
        icon: <img src={McaCompanyDetails} alt="McaCompanyDetails" height="40px" />,
        path: "/atom-pro/mca/services/check-company-llp-details",
    },

];

const McaServices = () => {
    const navigate = useNavigate();
    useTitle("ATOM Pro | MCA");

    return (

        <Box
            sx={{
                minHeight: "100vh",
                px: { xs: 2, md: 4 },
                py: 4,
                background: "linear-gradient(135deg, #f4f6fb, #e8ecf7)",
            }}
        >
            <Grid container spacing={4}>
                {services.map((service, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <Paper
                            onClick={() => navigate(service.path)}
                            elevation={0}
                            sx={{
                                p: 4,
                                borderRadius: "20px",
                                minHeight: 240,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                cursor: "pointer",

                                background: "rgba(255, 255, 255, 0.15)",
                                backdropFilter: "blur(16px)",
                                WebkitBackdropFilter: "blur(16px)",
                                border: "1px solid rgba(255,255,255,0.3)",

                                boxShadow: `
                                    0 8px 30px rgba(0,0,0,0.08),
                                    inset 0 1px 1px rgba(255,255,255,0.6)
                                `,

                                transition: "all 0.4s ease",

                                "&:hover": {
                                    transform: "translateY(-6px)",
                                    border: "1px solid rgba(37,99,235,0.4)",
                                    boxShadow: `
                  0 15px 40px rgba(37,99,235,0.25),
                  inset 0 1px 2px rgba(255,255,255,0.8)
                `,
                                },
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        width: 64,
                                        height: 64,
                                        borderRadius: "18px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 3,
                                        position: "relative",
                                        overflow: "hidden",

                                        background: "rgba(0, 0, 0, 0.55)",
                                        backdropFilter: "blur(14px)",
                                        WebkitBackdropFilter: "blur(14px)",
                                        border: "1px solid rgba(255,255,255,0.2)",

                                        boxShadow: `
      0 8px 25px rgba(0,0,0,0.35),
      inset 0 1px 2px rgba(255,255,255,0.2)
    `,

                                        transition: "all 0.4s ease",

                                        ".MuiPaper-root:hover &": {
                                            background: "rgba(37, 99, 235, 0.65)",
                                            boxShadow: `
        0 12px 35px rgba(37,99,235,0.6),
        inset 0 1px 2px rgba(255,255,255,0.5)
      `,
                                            transform: "translateY(-4px)",
                                        },

                                        "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "50%",
                                            background: "linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0.05))",
                                            pointerEvents: "none",
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            zIndex: 2,
                                            filter: "brightness(1.2)",
                                        }}
                                    >
                                        {service.icon}
                                    </Box>
                                </Box>


                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                    sx={{ color: "#111" }}
                                >
                                    {service.title}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{ color: "rgba(0,0,0,0.6)", mt: 1 }}
                                >
                                    {service.subtitle}
                                </Typography>
                            </Box>

                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    mt: 3,
                                    borderRadius: "14px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                    color: "#fff",
                                    background: "rgba(0, 0, 0, 0.6)",
                                    backdropFilter: "blur(12px)",
                                    WebkitBackdropFilter: "blur(12px)",
                                    border: "1px solid rgba(255,255,255,0.2)",

                                    boxShadow: `
                  0 6px 20px rgba(0,0,0,0.4),
                  inset 0 1px 1px rgba(255,255,255,0.2)
                `,
                                    "&:hover": {
                                        background: "rgba(37, 99, 235, 0.7)",
                                        border: "1px solid rgba(255,255,255,0.4)",
                                        transform: "translateY(-2px)",
                                        boxShadow: `
                    0 12px 30px rgba(37,99,235,0.6),
                    inset 0 1px 2px rgba(255,255,255,0.5)
                  `,
                                    },

                                    "&:active": {
                                        transform: "translateY(0px)",
                                        boxShadow: `
                    0 4px 12px rgba(0,0,0,0.4),
                    inset 0 3px 6px rgba(0,0,0,0.6)
                  `,
                                    },
                                }}
                            >
                                Search
                            </Button>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

};

export default McaServices;
